<template>
  <div class="space-y-2">
    <UFileUpload
      v-model="selectedFile"
      accept="image/*,.pdf,.doc,.docx,application/pdf"
      label="Trage fișierul aici sau click pentru a selecta"
      description="Imagini, PDF sau Word"
      icon="i-heroicons-cloud-arrow-up"
      color="neutral"
      class="w-full min-h-36"
      :disabled="uploading"
      @update:model-value="onFileSelected"
    />

    <div
      v-if="uploading"
      class="flex items-center gap-2 text-sm text-muted"
    >
      <UIcon name="i-heroicons-arrow-path" class="size-4 animate-spin" />
      Se încarcă fișierul...
    </div>

    <div
      v-else-if="modelValue"
      class="flex items-center gap-2 rounded-md bg-elevated px-3 py-2 text-sm ring ring-inset ring-accented"
    >
      <UIcon name="i-heroicons-document-check" class="size-5 shrink-0 text-success" />
      <a
        :href="mediaUrl(modelValue)"
        target="_blank"
        rel="noopener noreferrer"
        class="min-w-0 flex-1 truncate text-highlighted hover:underline"
      >
        {{ fileLabel }}
      </a>
      <UButton
        type="button"
        icon="i-heroicons-x-mark"
        color="neutral"
        variant="ghost"
        size="xs"
        aria-label="Elimină fișierul"
        @click="clearFile"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue?: string | null
}>()

const emit = defineEmits<{
  'update:modelValue': [value: string | null]
}>()

const { api } = useApi()
const { mediaUrl } = useMediaUrl()
const toast = useToast()

const selectedFile = shallowRef<File | null>(null)
const uploading = ref(false)

const fileLabel = computed(() => {
  if (!props.modelValue) return ''
  const parts = props.modelValue.split('/')
  return parts[parts.length - 1] || props.modelValue
})

async function onFileSelected(file: File | File[] | null | undefined) {
  const next = Array.isArray(file) ? file[0] : file
  if (!next) return

  uploading.value = true
  try {
    const formData = new FormData()
    formData.append('file', next)
    const { data } = await api.post<{ success: boolean; data?: { url: string; name?: string } }>(
      '/products/complex-field-upload',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120_000 },
    )
    if (data.success && data.data?.url) {
      emit('update:modelValue', data.data.url)
      toast.add({ title: 'Fișier încărcat', color: 'success' })
    } else {
      selectedFile.value = null
      toast.add({ title: 'Încărcarea fișierului a eșuat', color: 'error' })
    }
  } catch {
    selectedFile.value = null
    toast.add({ title: 'Încărcarea fișierului a eșuat', color: 'error' })
  } finally {
    uploading.value = false
  }
}

function clearFile() {
  selectedFile.value = null
  emit('update:modelValue', null)
}
</script>
